import React from "react";
import { Overline } from "./Shared";
import { useReveal } from "../hooks/useReveal";

export const About = ({ t }) => {
  const a = t.about;
  const { ref, visible } = useReveal();

  return (
    <section id="about" data-testid="about-section" className="relative py-24 sm:py-32 bg-aa-green">
      <div ref={ref} className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        {/* Image */}
        <div className={`relative reveal ${visible ? "is-visible" : ""}`}>
          <div className="absolute -top-4 -left-4 w-24 h-24 border-t border-l border-aa-gold/50" />
          <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b border-r border-aa-gold/50" />
          <img
            src="https://images.pexels.com/photos/33685860/pexels-photo-33685860.jpeg"
            alt="A&A Immobiliers"
            className="w-full h-[420px] sm:h-[520px] object-cover"
          />
        </div>

        {/* Text */}
        <div className={`reveal ${visible ? "is-visible" : ""}`} style={{ transitionDelay: "0.15s" }}>
          <Overline>{a.overline}</Overline>
          <h2 className="font-heading font-light text-aa-cream mt-5 text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
            {a.title}
          </h2>
          <div className="mt-6 space-y-5 font-body font-light text-aa-cream/75 text-base sm:text-lg leading-relaxed">
            <p>{a.p1}</p>
            <p className="text-aa-gold italic">{a.p2}</p>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-6 border-t border-aa-gold/20 pt-8">
            {a.stats.map((s, i) => (
              <div key={i} data-testid={`about-stat-${i}`}>
                <div className="font-heading text-2xl sm:text-3xl text-aa-gold font-medium">{s.value}</div>
                <div className="font-body text-xs sm:text-sm text-aa-cream/60 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
